(() => {
  const key = "rr:inquiry:pages:v1";
  const field = "contact[Pages visited before inquiry]";
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
  const clean = page => {
    if (!page || typeof page.url !== "string" || typeof page.title !== "string") return null;
    try {
      const url = new URL(page.url, location.origin);
      if (url.origin !== location.origin || !/^\/(?:$|(?:products|collections|pages|blogs|policies)(?:\/|$))/.test(url.pathname)) return null;
      return { title: page.title.replace(/[\r\n\t]/g, " ").slice(0, 180), url: url.origin + url.pathname };
    } catch { return null; }
  };
  const read = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(key) || "null");
      if (!value || !Number.isFinite(value.expires) || value.expires < Date.now() || !Array.isArray(value.pages)) return [];
      return value.pages.map(clean).filter(Boolean).slice(-20);
    } catch { return []; }
  };
  const record = () => {
    if (!allowed()) { clear(); return; }
    const page = clean({ title: document.title, url: location.href });
    if (!page) return;
    const pages = read();
    if (pages.at(-1)?.url !== page.url) pages.push(page);
    try { sessionStorage.setItem(key, JSON.stringify({ expires: Date.now() + 1800000, pages: pages.slice(-20) })); } catch {}
  };
  document.addEventListener("visitorConsentCollected", record);
  window.addEventListener("pageshow", record);
  window.addEventListener("popstate", record);
  if (window.Shopify?.customerPrivacy) record();
  else window.Shopify?.loadFeatures?.([{ name: "consent-tracking-api", version: "0.1" }], error => { if (!error) record(); });
  document.addEventListener("formdata", event => {
    if (!event.target.matches?.("form[data-inquiry-contact-form]") ||
        !event.target.closest("rr-product-inquiry, rr-page-inquiry")) return;
    event.formData.delete(field);
    if (!allowed()) { clear(); return; }
    record();
    const pages = read();
    if (pages.length) event.formData.append(field, pages.map((page, i) => `${i + 1}. ${page.title}\n${page.url}`).join("\n\n"));
  }, true);
})();
